import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
};

const demoRequests = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_DEMO_REQUESTS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };

    default:
      return state;
  }
};

export default demoRequests;
